module.exports = __webpack_public_path__ + "static/scale-model-of-paseo-de-la-fama-in-glendale-california-474729a63f04b3497b8966726593210e.png";